import { proxy } from 'valtio';
import { valtioDevTools } from '@lib/utils/devTools';
import { ModalId } from './types';

export const modalsState = proxy<{
  activeModalId: ModalId | null;
  props: Record<string, any>; // Props for the active modal
}>({
  activeModalId: null,
  props: {},
});

valtioDevTools(modalsState, 'modalsState');

// Generic function to open a modal
const openModal = (modalId: ModalId, props: Record<string, any> = {}) => {
  modalsState.activeModalId = modalId;
  modalsState.props = props;
};

// Function to close the currently active modal
const closeModal = () => {
  modalsState.activeModalId = null;
  modalsState.props = {};
};

export const modalsActions = {
  openModal,
  closeModal,
};
